import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "importAdditionalinfoType",
            label: "Type",
            component: "dropdown",
            endIconName: "LuChevronDown",
            placeholder: "Item Category",
            options: [
              { label: "Item Characteristics", value: "Item Characteristics" },
              { label: "Item Category", value: "Item Category" },
              { label: "Item Identification", value: "Item Identification" },
              { label: "Origin Criteria", value: "Origin Criteria" },
              {
                label: "PGA Exception category",
                value: "PGA Exception category",
              },
              { label: "Product Name", value: "Product Name" },
            ],
            width : "50%",

          },
          {
            name: "importAdditionalinfoQualifier",
            label: "Qualifier",
            component: "dropdown",
            endIconName: "LuChevronDown",
            placeholder: "Food Supplement",
            options: [
              { label: "Breed", value: "Breed" },
              { label: "Colour", value: "Colour" },
              { label: "GSTALLOWED", value: "GSTALLOWED" },
              { label: "Plant Variety", value: "Plant Variety" },
              { label: "Sex", value: "Sex" },
              { label: "Storage Condition", value: "Storage Condition" },
              { label: "Storage Temperature", value: "Storage Temperature" },
            ],
            width : "50%",


          },
        ],
        row2: [
          {
            name: "importAdditionalinfoCode",
            label: "Code",
            component: "text-field",
            endpointWithParams: "type",
            type: "autocomplete",
            endpoint: "getQualifierCode",
            useParams: "importAdditionalinfoQualifier",
            dependsOn: "importAdditionalinfoQualifier",
            dependsValue: ["sex","storageCondition","drugRelatedCategory","foodsupplementproperty","gradeofproduct","labcoursecleared","plantCategory","plantParts","PQAException_PROD2016","PQAException_DCO2016","PlantCommodityName"],

          },
          {
            name: "importAdditionalinfoInformation",
            label: "Information",
            component: "text-field",
            dependsOn: "importAdditionalinfoQualifier",
            dependsValue: ["breed","colour","plantVariety","sex","storageCondition","eticketnumber","passportnumber","pnrnumbeScientificNamer","animalpassportnumber","ElectronicComponet","chemicalabstrack","GlobalradeItemNumber","MicrochipsNumbersInsertedInto","VehicleIdentificationNumber","productSpecificRules","valueAdded","WhollyObtainedProducted","commonName","InternationalNonProprietaryName","NameasContainedinaPharmacopeia","NamePertheIUPACNomenclature","NameoftheLiveStockProduct","NameoftheModel","petname","PlantCommodityName","ScientificName","TradeorCommercialName",],

          },
        ],
        row3: [
          {
            name: "importAdditionalinfoMeasure",
            label: "Measure",
            component: "text-field",
            placeholder: "1000.00",
            dataType: "float",
          },
          {
            name: "importAdditionalinfoMeasureUnit",
            label: "Measure Unit",
            component: "text-field",
            placeholder: "Kg",
            type: "autocomplete",
            endpoint: "getQuantity",
            icon: LuSearch,
          },
        ],
      },
    },
  ],
};
